<template>
    <div class="stage-map" :style="cssStyle">
        <div class="center-line" />
        <div class="inner">
            <div
                v-for="(stage, index) in stages"
                :key="index"
                class="stage"
                :class="{
                    [`stage-${index}`]: true,
                    disabled: !isAllowToPlay(stage.openDate)
                }"
                @click="goToStage(index, isAllowToPlay(stage.openDate))"
            >
                <img
                    v-if="progress && progress[`stage${index}`] !== undefined"
                    src="@/assets/game/map/pass.png"
                    class="pass-stamp"
                />
                <img
                    v-if="isAllowToPlay(stage.openDate)"
                    :src="
                        require(`@/assets/game/map/stage_enabled_${index}.png`)
                    "
                />
                <img
                    v-else
                    :src="require(`@/assets/game/map/stage${index}.png`)"
                />
            </div>
            <div
                class="pass-button"
                :class="{ disabled: !isPass }"
                @click="gotoLottery"
            >
                <div class="text">
                    <span v-if="!isPass">完成任一關卡即可抽獎</span>
                </div>
                <img
                    v-if="isPass"
                    src="@/assets/game/map/btn_enabled.png"
                    alt=""
                />
                <img v-else src="@/assets/game/map/btn.png" alt="" />
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import moment from 'moment';
import _ from 'lodash';
import StageConfig from '@/config/stageMap';

export default {
    data() {
        return {
            stages: [...StageConfig]
        };
    },
    computed: {
        ...mapState({
            progress: state => state.progress
        }),
        isPass() {
            let progressNum = 0;
            _.forEach(this.progress, () => {
                progressNum += 1;
            });
            return progressNum >= 1;
        },
        cssStyle() {
            return `--navbar-height: ${this.$root.navbarHeight}px`;
        },
        lotteryLink() {
            return process.env.VUE_APP_LOTTERY_LINK;
        }
    },
    methods: {
        isAllowToPlay(date) {
            const CURRENT_TIME = process.env.VUE_APP_CURRENT_TIME;
            const IS_DATE_PASSED = !moment(date).isAfter(moment(CURRENT_TIME));
            return IS_DATE_PASSED;
        },
        goToStage(index, allow) {
            if (allow)
                this.$router.push({
                    name: 'Game_Stage',
                    params: { stage: index }
                });
        },
        gotoLottery() {
            if (this.isPass) {
                liff.openWindow({
                    url: this.lotteryLink
                });
            }
        }
    }
};
</script>

<style lang="scss" scoped>
$navbar-height: var(--navbar-height);

.stage-map {
    position: relative;
    max-width: 414px;
    margin: auto;
    padding: $navbar-height 0;
    .center-line {
        position: absolute;
        top: 90px;
        left: 50%;
        transform: translate(-50%, $navbar-height);
        background-color: #eddba2;
        width: 40px;
        height: 80%;
    }
    .inner {
        position: relative;
        z-index: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .stage {
        position: relative;
        cursor: pointer;
        width: 80%;
        &.disabled {
            cursor: not-allowed;
        }
        .pass-stamp {
            position: absolute;
            width: 30%;
            bottom: 30%;
            right: 15%;
        }
    }
    .pass-button {
        margin-top: 40px;
        width: 90%;
        display: flex;
        flex-direction: column;
        align-items: center;
        .text {
            height: 30px;
            margin-bottom: 10px;
        }
        img {
            cursor: pointer;
        }
        &.disabled {
            img {
                cursor: not-allowed;
            }
        }
    }
}
</style>
